import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	LikePetitionSupporterComment,
	type LikePetitionSupporterCommentMutation,
	type LikePetitionSupporterCommentMutationVariables,
} from './likeSupporterComment.graphql';

export async function likeSupporterComment(commentId: string, { gql: { fetch } }: UtilityContext): Promise<void> {
	const { data } = await fetch<LikePetitionSupporterCommentMutation, LikePetitionSupporterCommentMutationVariables>({
		query: LikePetitionSupporterComment,
		variables: { commentId },
		rejectOnError: true,
		batched: false,
	});

	if (!data.likePetitionSupporterComment.success) {
		throw new Error('Like failed');
	}
}
